<template>
  <validation-observer ref="formValidate">
    <b-overlay
      :show="loader.general"
      rounded="sm"
    >
      <b-form
        class="pt-1 pb-2 px-2"
        @submit.prevent="validationForm"
      >
        <b-row cols="12">
          <!-- Tipo de evento -->
          <b-col cols="12">
            <b-skeleton-wrapper :loading="loader.tipos">
              <!-- Loader -->
              <template #loading>
                <b-skeleton
                  class="my-2"
                  type="button"
                  width="100%"
                />
              </template>
              <b-form-group
                label="Tipo de evento"
                label-for="id-tipos"
              >
                <validation-provider
                  #default="{ errors }"
                  name="tipo de evento"
                  rules="required"
                >
                  <b-form-input
                    v-show="false"
                    v-model="typeSelected"
                    readonly
                  />
                  <b-dropdown
                    id="id-tipos"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    block
                    :text="nameType"
                    :variant="typeSelected ? 'primary' : (errors.length > 0) ? 'danger' : 'secondary'"
                  >
                    <b-dropdown-item
                      v-for="t in tipos"
                      :key="t.id"
                      v-b-tooltip.hover.left="([2,3,9,10,11,12,13].find(element => element === t.id) > -1) ? 'No puede ingresar más de un registro de este tipo' : ''"
                      :variant="typeSelected === t.id ? 'primary' : ''"
                      @click="typeSelected !== t.id ? typeSelected = t.id : ''"
                    >
                      <feather-icon
                        v-if="([2,3,9,10,11,12,13].find(element => element === t.id) > -1)"
                        icon="AlertCircleIcon"
                      />
                      {{ t.nombre }}
                    </b-dropdown-item>
                  </b-dropdown>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-skeleton-wrapper>
          </b-col>
          <!-- Nombre -->
          <b-col cols="12">
            <b-form-group
              label="Nombre"
              label-for="name"
              class="mb-2"
            >
              <validation-provider
                #default="{ errors }"
                name="nombre"
                rules="required"
              >
                <b-form-input
                  id="name"
                  v-model="form.evento"
                  type="text"
                  placeholder="Ingrese nombre del evento"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Descripción -->
          <b-col cols="12">
            <b-form-group
              label="Descripción"
              label-for="info"
              class="mb-2"
            >
              <b-form-input
                id="info"
                v-model="form.descripcion"
                type="text"
                placeholder="Ingrese una descripción breve"
              />
            </b-form-group>
          </b-col>
          <!-- Fecha inicial -->
          <b-col sm="6">
            <b-form-group
              label="Fecha de inicio"
              label-for="fechaIni"
              class="mb-2"
            >
              <validation-provider
                #default="{ errors }"
                name="fecha de inicio"
                rules="required"
              >
                <flat-pickr
                  id="fechaIni"
                  v-model="form.fechaIni"
                  class="form-control"
                  :config="configFlatPickr"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Fecha de fin -->
          <b-col sm="6">
            <b-form-group
              label="Fecha de fin"
              label-for="fechaFin"
              class="mb-2"
            >
              <validation-provider
                #default="{ errors }"
                name="fecha de fin"
                rules="required"
              >
                <flat-pickr
                  id="fechaFin"
                  v-model="form.fechaFin"
                  class="form-control"
                  :config="configFlatPickr"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Color de fecha de inicio -->
          <b-col sm="6">
            <b-form-group
              label="Color de fecha de inicio"
              label-for="rgbIni"
              class="mb-50"
            >
              <validation-provider
                #default="{ errors }"
                name="color de inicio"
                rules="alpha_num"
              >
                <b-form-input
                  id="rgbIni"
                  v-model="form.rgbIni"
                  type="text"
                  placeholder="Color hexadecimal"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <div
              :style="form.rgbIni ? `background-color: #${form.rgbIni} !important;` : ''"
              class="text-center bg-secondary colors-container rounded text-white height-45 d-flex align-items-center justify-content-center shadow mb-2"
            >
              <span>{{ form.rgbIni ? '#'+form.rgbIni : 'Sin asignar' }}</span>
            </div>
          </b-col>
          <!-- Color de fecha de fin -->
          <b-col sm="6">
            <b-form-group
              label="Color de fecha de fin"
              label-for="rgbFin"
              class="mb-50"
            >
              <validation-provider
                #default="{ errors }"
                name="color de fin"
                rules="alpha_num"
              >
                <b-form-input
                  id="rgbFin"
                  v-model="form.rgbFin"
                  type="text"
                  placeholder="Color hexadecimal"
                  :disabled="([7,9,13].find(element => element === typeSelected) > -1)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <div
              :style="form.rgbFin ? `background-color: #${form.rgbFin} !important;` : ''"
              class="text-center bg-secondary colors-container rounded text-white height-45 d-flex align-items-center justify-content-center shadow mb-2"
            >
              <span>{{ form.rgbFin ? '#'+form.rgbFin : 'Sin asignar' }}</span>
            </div>
          </b-col>
          <!-- Evento exclusivo (indicador) -->
          <b-col cols="12">
            <b-skeleton-wrapper :loading="loader.roles">
              <!-- Loader -->
              <template #loading>
                <b-skeleton
                  type="button"
                  width="100%"
                />
              </template>
              <div
                class="text-center cursor-pointer my-75"
                @click="exclusiveEvent = !exclusiveEvent"
              >
                <b-badge
                  :variant="`${exclusiveEvent ? 'warning' : 'light-warning'}`"
                  class="mr-75 badge-glow"
                >
                  <feather-icon icon="LockIcon" />
                </b-badge>
                <span><b>Presione para asignar exclusividad sobre grupos</b></span>
              </div>
            </b-skeleton-wrapper>
          </b-col>
          <!-- Roles exclusivos -->
          <b-col cols="12">
            <div
              v-if="exclusiveEvent"
              class="mt-1 mb-2"
            >
              <b-form-checkbox
                v-for="item in availableExclusiveGroups"
                :key="item.id"
                v-model="exclusiveGroups"
                :value="item.id"
              >
                {{ item.nombre }}
              </b-form-checkbox>

              <div class="mt-2 text-center border-top">
                <small>Grupos disponibles para asignar (grupos que aún no ha asignado)</small>
              </div>

            </div>
            <div
              v-else
              class="text-center mb-2"
            >
              <small><b>Un evento exclusivo (no será visible para el público, solo roles específicos)</b></small>
            </div>
          </b-col>

          <!-- Botón de guardado -->
          <b-col cols="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              block
              variant="primary"
              @click.prevent="validationForm"
            >
              Guardar datos
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-overlay>
  </validation-observer>
</template>

<script>
import {
  ref, watch, computed, onMounted,
} from '@vue/composition-api'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BForm,
  BDropdown,
  BDropdownItem,
  BBadge,
  VBTooltip,
  BOverlay,
  BFormCheckbox,
  BSkeletonWrapper,
  BSkeleton,
} from 'bootstrap-vue'
import { isObject, isEmptyObject, formhttp } from '@core/utils/utils'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import { getData } from '@core/utils/http/general'
import flatPickr from 'vue-flatpickr-component'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getTypes, saveScheadule } from '../../usePeriodos'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BDropdown,
    BDropdownItem,
    BBadge,
    BOverlay,
    BButton,
    flatPickr,
    BFormCheckbox,
    BSkeletonWrapper,
    BSkeleton,

    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  props: {
    toEdit: {
      type: Object,
      default: () => {},
    },
    periodo: {
      type: [Number, null],
      default: null,
    },
  },
  setup(props, { emit }) {
    const toast = useToast()
    const form = ref({})
    const exclusiveGroups = ref([])
    const exclusiveEvent = ref(false)
    const typeSelected = ref(null)
    const loader = ref({ roles: false, tipos: false, general: false })
    const formValidate = ref(null)
    const configFlatPickr = {
      enableTime: true, enableSeconds: true, altInput: true, minuteIncrement: 1, altFormat: 'd-m-Y H:i:s', dateFormat: 'U',
    }
    const exclusiveData = ref([])
    const tipos = ref([])

    // * Cargar catálogo de roles
    const getRoles = () => {
      loader.value.roles = true
      const paramsRequest = {
        action: 7,
        token: store.state.cuenta.session.token,
      }
      getData(paramsRequest, 'wsusuarios')
        .then(response => {
          loader.value.roles = false
          if (response.status === 200) {
            exclusiveData.value = response.data.data || []
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Error cargando roles',
                text: response.data.message,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 10000 })
          }
        }, error => {
          loader.value.roles = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error cargando roles',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }

    // * Cargar catálogo de tipos de eventos
    const fillTypes = () => {
      emit('loading-types', true)
      loader.value.tipos = true
      getTypes().then(response => {
        emit('loading-types', false)
        loader.value.tipos = false
        tipos.value = response.data || []
        emit('fill-types', tipos.value)
        if (!response.status === 200) {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error cargando tipos',
              text: response.data.message,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        }
      }, error => {
        emit('loading-types', false)
        loader.value.tipos = false
        tipos.value = []
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error cargando tipos',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 10000 })
      })
    }

    // * Retornar nombre de temporalidad seleccionada
    const nameType = computed(() => {
      if (typeSelected.value) return tipos.value.find(item => item.id === typeSelected.value).nombre
      return 'Seleccione tipo'
    })

    // * Retornar los roles disponibles para exclusividad (no muestra los que ya están relacionados)
    const availableExclusiveGroups = computed(() => {
      if (props.toEdit.exclusivo && props.toEdit.exclusivo.length) return exclusiveData.value.filter(item => !props.toEdit.exclusivo.find(selected => selected.id === item.id))
      return exclusiveData.value
    })

    // * Precargamos datos a editar
    watch(() => props.toEdit, data => {
      if (data && isObject(data) && !isEmptyObject(data)) {
        form.value = {
          descripcion: data.descripcion,
          evento: data.evento,
          fechaFin: data.fechaFin * 1000,
          fechaIni: data.fechaIni * 1000,
          id: data.id,
          rgbFin: data.rgbFin,
          rgbIni: data.rgbIni,
        }

        typeSelected.value = data.tipo
        exclusiveEvent.value = !!((data.exclusivo && data.exclusivo.length))
        exclusiveGroups.value = []
        // if (data.exclusivo && data.exclusivo.length) data.exclusivo.forEach(element => { exclusiveGroups.value.push(element.id) })
      } else {
        form.value = {}
        typeSelected.value = null
        exclusiveGroups.value = []
        exclusiveEvent.value = false
      }
    })

    // * Guarda datos
    const saveData = () => {
      const data = {
        action: 3,
        descripcion: form.value.descripcion,
        evento: form.value.evento,
        fechaFin: form.value.fechaFin,
        fechaIni: form.value.fechaIni,
        rgbFin: form.value.rgbFin,
        rgbIni: form.value.rgbIni,
        tipo: typeSelected.value,
        periodo: props.periodo,
      }

      // * Prepara data para edición
      if (props.toEdit && isObject(props.toEdit) && !isEmptyObject(props.toEdit)) {
        data.action = 4
        data.id = form.value.id
      }

      // * Agrega grupos exclusivos cuando bandera sea true
      if (exclusiveEvent.value) data.grupos = JSON.stringify(exclusiveGroups.value)

      loader.value.general = true
      saveScheadule(data).then(response => {
        loader.value.general = false
        const { icon, label } = formhttp(response.status)
        if (response.status === 200) emit('reload-data')

        toast({
          component: ToastificationContent,
          props: {
            title: 'Respuesta de solicitud',
            text: response.message,
            icon,
            variant: label,
          },
        },
        { timeout: 8000 })
      }, error => {
        loader.value.general = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error en petición [Guardar datos]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      })
    }

    // * Validación de formulario
    const validationForm = () => {
      formValidate.value.validate().then(success => {
        if (success) saveData()
      })
    }

    onMounted(() => {
      getRoles()
      fillTypes()
    })

    return {
      // Data
      form,
      tipos,
      typeSelected,
      exclusiveEvent,
      exclusiveGroups,
      loader,

      // Refs
      formValidate,

      // Function
      validationForm,

      // Computed
      nameType,
      availableExclusiveGroups,

      // Filter
      required,
      isObject,
      isEmptyObject,
      configFlatPickr,

    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/pages/page-faq.scss';
</style>
